import IBean from './beans/IBean'
import IReader from './readers/IReader'
import IOperaton from './operations/IOperation'
import { getBeans } from './beanFactory'

/**
 * 调度器
 */
export default class Dispatcher {
    /**
     * 构造函数
     * @param {mapboxgl.map} map
     */
    constructor(wpsUrl, proxyUrl) {
        this._wpsUrl = wpsUrl
        this._proxyUrl = proxyUrl
    }

    /**
     * @api
     * 方法入口
     * @param {String} operationType
     */
    async dispatch(operationType, ...rest) {
        // 进行分析
        return this.findOpeation(operationType).process(...rest)
    }

    /**
     * 读取数据
     * @param {IBean} iBean
     */
    async read(iBean) {
        return this.findReader(iBean).read(iBean)
    }

    /**
     * 查找Reader
     * @param {IBean} v
     * @returns {IReader}
     */
    findReader(v) {
        const readers = getBeans(IReader).filter(r => r.check(v))
        if (readers.length) {
            return readers[0]
        }
        console.error('FindReader error:', v)
        throw 'FindReader: 暂不支持的数据格式！'
    }

    /**
     * 查找operation
     * @param {String} type
     * @returns {IOperaton}
     */
    findOpeation(type) {
        const operations = getBeans(
            IOperaton,
            this._wpsUrl,
            this._proxyUrl
        ).filter(r => r.check(type))
        if (operations.length) {
            return operations[0]
        }
        console.error('FindOpeation error:', type)
        throw 'FindOpeation: 暂不支持的分析操作！'
    }
}

/**
 * 获取分析工具
 */
export function getDispatcher() {
    let wpsUrl = global.CONFIG.analysisConf && global.CONFIG.analysisConf.url || ""
    return new Dispatcher(wpsUrl, GeoGlobe.ProxyHost)
}
